import { render, staticRenderFns } from "./AcceptDialog.vue?vue&type=template&id=b2238b7a&"
import script from "./AcceptDialog.vue?vue&type=script&lang=js&"
export * from "./AcceptDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports